import { useState } from "react";
import { config } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";
import {
  disabledIfFieldChecker,
  findDataInFields,
} from "../../utils/helperFuctions";
import ErrorAlerts from "../Alerts/ErrorAlerts";
import { updateShowFieldsByIndex } from "../../redux/showFieldsSlice";
import { useDispatch } from "react-redux";

const AsyncButton = ({
  text,
  param,
  apiUrl,
  value,
  handleChange,
  callPopUp,
  activeWhenFieldValues,
  id,
  fields,
  ignore,
  disabledIfField,
  errors,
  paramObj,
  setErrors,
  validateField,
  fieldsToValidate,
  formData,
  handleSubmit,
  updateShowFields,
  disabled,
  customValidate,
  currentFields,
}) => {
  // const isValid = Object.values(errors).every((error) => error === "");
  const isValid = true;
  const dispatch = useDispatch();
  let param2 = null;
  if (paramObj != null && paramObj["vehicle"] != null) {
    const id = findDataInFields(fields, "vehicle.defaultValue").id;
    param2 = {
      ...paramObj,
      vehicle: {
        ...paramObj.vehicle,
        id: id,
      },
    };
  }

  const checkDisabled = () => {
    let isDisabled = disabled || false;
    if (isDisabled === true) return true;
    activeWhenFieldValues.forEach((element) => {
      const value = findDataInFields(fields, element);

      if (
        value === false ||
        value == null ||
        (typeof value === "string" && value.trim() === "")
      ) {
        isDisabled = true;
      } else {
        isDisabled = false;
      }
    });
    const ignoreIf = findDataInFields(fields, ignore.if);
    const branchcode = findDataInFields(fields, "branch.code");

    if (ignoreIf === true && branchcode != "LB") {
      const value = findDataInFields(fields, ignore.value);
      if (
        value === false ||
        value == null ||
        (typeof value === "string" && value.trim() === "")
      ) {
        isDisabled = true;
      }
    }
    return isDisabled;
  };
  const disabledbutton = checkDisabled();

  const handleButtonClick = async (e) => {
    if (e) {
      e.preventDefault();
    }
    if (customValidate != null) {
      const error = customValidate.find((validate) => {
        const val = findDataInFields(currentFields, validate.field, true);

        return val === validate.notEqual;
      });

      if (error != null) {
        callPopUp({
          title: "Validation Error",
          description: `${error.field.split(".")[0]} is required`,
          isError: true,
          showPopUp: true,
          hideCancel: true,
        });
        return;
      }
    }
    if (fieldsToValidate != null) {
      let newErrors = {};

      for (const field of fieldsToValidate) {
        const fieldError = await validateField(field, formData[field]);

        if (fieldError != null) {
          newErrors = { ...newErrors, [field]: fieldError };
        }
      }

      const isError = !Object.values(newErrors).every((error) => error === "");

      setErrors((prev) => ({
        ...prev,
        ...newErrors,
      }));
      if (isError) {
        if (callPopUp instanceof Function) {
          const sendErrors = Object.values(newErrors).filter((x) => x !== "");
          callPopUp({
            title: "",
            description: "",
            isError: true,
            showPopUp: true,
            hideCancel: true,
            children: (
              <ErrorAlerts title={"Validation Error"} list={sendErrors} />
            ),
          });
        }

        return;
      } else {
        const s = await handleSubmit(e, undefined, true);
        if (s === false) return;
      }
    }

    if (param) {
      const _e = {
        target: {
          name: param,
          value: value,
        },
      };

      // handleChange(_e);
      if (apiUrl && id) {
        try {
          // if (callPopUp instanceof Function) {
          //   callPopUp({
          //     title: "Saving data...",
          //     showPopUp: true,
          //     hideCancel: true,
          //     hideMainButton: true,
          //     showLoading: true,
          //   });
          // }

          fetch(`${config.apiUrl}/api/${apiUrl}/${id}`, {
            method: "PUT", // specify the HTTP method
            headers: {
              "Content-Type": "application/json", // set the Content-Type header if sending JSON data
              // add any other headers if necessary
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
            body: JSON.stringify({
              [param]: value,
              ...param2,
            }), // convert data to JSON string if sending JSON data
          })
            .then((response) => {
              // handle the response
              if (response.status >= 200 && response.status <= 299) {
                // updateShowFields(newFormData, name);
                if (callPopUp instanceof Function) {
                  callPopUp({
                    isError: false,
                    title: `Reservation marked as ${value}`,
                    showPopUp: true,
                    hideCancel: true,
                  });

                  const toChangeIndex = fields.findIndex(
                    (x) => x.name === param
                  );
                  dispatch(
                    updateShowFieldsByIndex({
                      index: toChangeIndex,
                      toChange: {
                        ...fields[toChangeIndex],
                        defaultValue: value,
                      },
                    })
                  );
                } else {
                  alert("Saved Successfully");
                }
              }
            })
            .catch((error) => {
              // handle errors
              console.log(error?.message);
            });
        } catch (error) {
          console.log(error?.message);
        }
      }
    }
  };
  const isFieldDisabled =
    disabledIfField != null
      ? disabledbutton ||
        disabledIfFieldChecker(fields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabledbutton;

  const isDisabled = isFieldDisabled === true || isValid === false;

  return (
    <div className=" flex justify-center items-center">
      <button
        disabled={isDisabled}
        className={`px-4 py-2 text-white rounded transition-colors ${
          isDisabled
            ? "bg-primary/50 cursor-not-allowed"
            : "bg-primary hover:bg-blue-600 cursor-pointer"
        }`}
        onClick={handleButtonClick}
      >
        {text}
      </button>
    </div>
  );
};

export default AsyncButton;
